import { render, staticRenderFns } from "./detailsDevoirLocal.vue?vue&type=template&id=0be20fb6&"
import script from "./detailsDevoirLocal.vue?vue&type=script&lang=js&"
export * from "./detailsDevoirLocal.vue?vue&type=script&lang=js&"
import style0 from "./detailsDevoirLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports